import {
    Button,
    Col,
    DatePicker,
    Form,
    Input,
    Row,
    Typography
} from "antd";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
    loadAllAttendance,
} from "../../redux/rtk/features/attendance/attendanceSlice";
import { addLinkUser, loadAllIndivisualUser } from "../../redux/rtk/features/linkUser/linkUserSlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import LinkCompanyTblData from "./linkCompanyTblData";

const LinkCompany = ({ drawer }) => {
    const [loader, setLoader] = useState(false);
    const [selectedJoinDate, setSelectedJoinDate] = useState(null);
    const [selectedUserId, setSelectedUserId] = useState('');
    const [selectedUserName, setSelectedUserName] = useState('');
    const users = useSelector((state) => state.linkUser?.linkUser?.map(user => ({
        
        // id: user.id.toString(), // Ensuring id is string for comparison
        id: user?.id?.toString() ?? "",
        userName: user.userName,
        joinDate: user.joinDate
    })));
    const dispatch = useDispatch();
    const { Title } = Typography;
    const [form] = Form.useForm();

    useEffect(() => {
        dispatch(loadAllIndivisualUser());
    }, [dispatch]);

    const onFinish = async (values) => {
        if (values.joinDate) {
            const formattedDate = moment(values.joinDate).format("YYYY-MM-DD");
            values.joinDate = formattedDate;
        }
        setLoader(true);
        const resp = await dispatch(addLinkUser({ id: selectedUserId}));
        if (resp.payload.message === "success") {
            setLoader(false);
            form.resetFields();
            dispatch(loadAllAttendance());
        } else {
            setLoader(false);
        }
    };

    const onFinishFailed = (errorInfo) => {
        toast.warning("Failed at updating user information");
        setLoader(false);
    };

    const handleUserIdChange = (e) => {
        const userId = e.target.value;
        setSelectedUserId(userId);
        form.setFieldsValue({ userName: null, joinDate: null });
        setSelectedUserName('');
        setSelectedJoinDate(null);
    };

    const handleUserNameChange = (e) => {
        const userName = e.target.value;
        setSelectedUserName(userName);
        const selectedUser = users.find(user => user.id === selectedUserId && user.userName === userName);
        if (selectedUser) {
            setSelectedJoinDate(moment(selectedUser.joinDate));
        } else {
            setSelectedJoinDate(null);
        }
    };

    const isPermissionGranted = selectedUserId && selectedUserName && users.some(user => user.id === selectedUserId && user.userName === selectedUserName);

    console.log("selectedUserId:", selectedUserId, "selectedUserName:", selectedUserName, "isPermissionGranted:", isPermissionGranted); // Debug log

    return (
        <Fragment>
            <UserPrivateComponent permission={"create-attendance"}>
                <Row className='mr-top' justify={drawer ? "center" : "space-between"}>
                    <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={drawer ? 22 : 12}
                        xl={drawer ? 22 : 12}
                        className='column-design border rounded card-custom'>
                        <Title level={4} className='m-2 mt-5 mb-5 text-center'>
                            User Information
                        </Title>

                        <Form
                            form={form}
                            style={{ marginBottom: "40px" }}
                            eventKey='shift-form'
                            name='basic'
                            labelCol={{
                                span: 6,
                            }}
                            wrapperCol={{
                                span: 12,
                            }}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            autoComplete='off'>
                            <div>
                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='User ID'
                                    name='userId'
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter a user ID!",
                                        },
                                    ]}>
                                    <Input
                                        placeholder='Enter User ID'
                                        onChange={handleUserIdChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='User Name'
                                    name='userName'
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter a user name!",
                                        },
                                    ]}>
                                    <Input
                                        placeholder='Enter User Name'
                                        onChange={handleUserNameChange}
                                    />
                                </Form.Item>

                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    label='Join Date'
                                    name='joinDate'
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select join date!",
                                        },
                                    ]}>
                                    <DatePicker
                                        format="DD-MM-YYYY"
                                        style={{ width: "100%" }}
                                        disabled={!isPermissionGranted}
                                    />
                                </Form.Item>

                                <Form.Item
                                    style={{ marginBottom: "10px" }}
                                    wrapperCol={{
                                        offset: 6,
                                        span: 12,
                                    }}>
                                    <Button
                                        onClick={() => setLoader(true)}
                                        type='primary'
                                        size='large'
                                        htmlType='submit'
                                        block
                                        loading={loader}
                                        disabled={!isPermissionGranted}>
                                        Update
                                    </Button>
                                </Form.Item>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </UserPrivateComponent>
                <LinkCompanyTblData/>

        </Fragment>
    );
};

export default LinkCompany;